(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".slideshow__swiper");
		slideshows.forEach((slideshow) => {
             if(!slideshow.swiper){
              const autoplay =
                  slideshow.getAttribute("data-autoplay") === "true" ? true : false;
              const loop = slideshow.getAttribute("data-disable-loop") === "true"?false: true;
              let slideshowSwiper;
              if(autoplay){
                slideshowSwiper = new Swiper(slideshow, {
                    navigation: {
                        nextEl: `#${slideshow.closest("section").id} .slideshow .swiper-button-next`,
                        prevEl: `#${slideshow.closest("section").id} .slideshow .swiper-button-prev`,
                    },
                    pagination: {
                      el: `#${slideshow.closest("section").id} .slideshow .swiper-pagination`,
                      clickable: true,
                    },
                    loop: loop,
                    autoplay: {
                      disableOnInteraction: false,
                    },
                    on: {
                      init() {
                        this.slideToLoop(0, 0, false);
                      }
                    }
                });
                
                // if (slideshowSwiper.addSlide.length < 2) {
                //     slideshowSwiper.allowTouchMove = false;
                // } else {
                //     slideshowSwiper.allowTouchMove = true;
                // }
                // if (slideshowSwiper.addSlide.length > 1)
                //     slideshow.classList.add("slideshow__swiper--multiple-slides");
              }else{
                slideshowSwiper = new Swiper(slideshow, {
                    navigation: {
                        nextEl: `#${slideshow.closest("section").id} .slideshow .swiper-button-next`,
                        prevEl: `#${slideshow.closest("section").id} .slideshow .swiper-button-prev`,
                    },
                    pagination: {
                      el: `#${slideshow.closest("section").id} .slideshow .swiper-pagination`,
                      clickable: true,
                    },
                    loop: loop
                });
                
                // if (slideshowSwiper.addSlide.length < 2) {
                //     slideshowSwiper.allowTouchMove = false;
                // } else {
                //     slideshowSwiper.allowTouchMove = true;
                // }
                // if (slideshowSwiper.addSlide.length > 1)
                //     slideshow.classList.add("slideshow__swiper--multiple-slides");
              }
              if (autoplay ) {
                  // slideshowSwiper.autoplay.start();
  
                  slideshow.addEventListener("mouseenter", () => {
                    console.log("mouseenter")
                      slideshowSwiper.autoplay.stop();
                  });
                  slideshow.addEventListener("mouseleave", () => {
                    console.log("mouseleave")
                      slideshowSwiper.autoplay.start();
                  });
              }
             }
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
